module.exports = __webpack_public_path__ + "media/stadium_theme.d1c95592.mp3";